<div class="error-page">
    <h1>Brak autoryzacji</h1>
    <p>Zostaniesz przekierowany na stronę logowania.</p>

    <button
        type="button"
        mat-flat-button
        (click)="goToLogin()"
    >
        Przejdź do strony logowania
    </button>
</div>
